<app-cabecalho-direita [data]="data.CABECALHO"></app-cabecalho-direita>

<section id="beneficios">
    <div *ngFor="let beneficio of data.BENEFICIOS; let index = index">
        <app-beneficio-esquerda *ngIf="index % 2 == 0" [data]="beneficio"></app-beneficio-esquerda>
        <app-beneficio-direita *ngIf="index % 2 !== 0" [data]="beneficio"></app-beneficio-direita>
    </div>
</section>